module.exports = __webpack_public_path__ + "media/brands/smart-55fc7008.png";